<template>
  <!--  采集人脸完成页面 -->
  <div>
    <van-nav-bar
      class="backBox"
      title="采集完成"
      right-text=""
      @click-left="onClickLeft"
    />
    <div class="content_box">
      <div class="main">
        <van-image
          width="140"
          height="140"
          fit="cover"
          :src="require('../../assets/imgs/collectionFaceOK@2x.png')"
        />
        <div class="title">采集完成！</div>
      </div>
      <div class="operationBtn" v-if="h5Config.funCfg.h5Type !== 3">
        <van-button round block type="info" @click="backIndex"
          >返回首页</van-button
        >
      </div>
      <div
        class="viewDetail"
        v-if="h5Config.funCfg.h5Type !== 3"
        @click="viewDetail"
      >
        查看详情
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {

    }
  },
  mounted () {
  },
  computed: {
    ...mapGetters([
      'h5Config'
    ])
  },
  methods: {
    backIndex () {
      this.$router.replace('/order')
    },
    viewDetail () {
      this.$router.replace('/myFaceInfo')
    },
    onClickLeft () {
      this.$router.go(-1)
    }

  }
}
</script>
<style scoped lang="scss">
.content_box {
  padding: 1rem;
  .main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .title {
      font-size: 1.3125rem;
      color: #74b0f9;
      margin-top: 1.6875rem;
    }
  }
  .operationBtn {
    margin: 1.4375rem 0 0 0;
  }
  .viewDetail {
    font-size: 1rem;
    color: #74b0f9;
    text-align: center;
    margin-top: 0.8125rem;
  }
}
</style>
